import type { EventSearchParams } from './types';

/**
 * Query keys for the Events feature.
 *
 * Namespaced under a single root so a mutation can invalidate the whole feature with one call when a
 * change has wide effects, or a single event when it does not. The search key carries the parameters
 * so a change of location, radius, date or type is a distinct query rather than a stale hit.
 */
export const eventKeys = {
  /** Every events query. */
  all: ['events'] as const,
  /** A discovery search for a given set of parameters. */
  search: (params: EventSearchParams) => [...eventKeys.all, 'search', params] as const,
  /** One event with everything attached. */
  event: (eventId: string) => [...eventKeys.all, 'event', eventId] as const,
  /** The caller's RSVPs. */
  myRsvps: () => [...eventKeys.all, 'my-rsvps'] as const,
  /** The moderation queue. */
  moderation: () => [...eventKeys.all, 'moderation'] as const,
};
